import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function Dashboard() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (loading) return;
    if (!user) { nav("/login", { replace: true }); return; }
    const dest = user.role === "dispatcher" ? "/dispatcher" : user.role === "driver" ? "/driver" : "/customer";
    nav(dest, { replace: true });
  }, [user, loading, nav]);
  return (
    <div data-testid="dashboard-loading" className="min-h-screen flex items-center justify-center bg-[#050505] text-[#A1A1AA]">
      <div className="overline">Loading your dashboard…</div>
    </div>
  );
}
